import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function TimeTable() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Time Table</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Time Table</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Time Table</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div class="col-lg-4 col-md-6">
                            <a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/pdf/Timetable/Prep.pdf#toolbar=0" target="_blank">
                                <div class="sample-blk">
                                    <p>PREP</p>
                                    <div class="lazyload-wrapper">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/pdf.png" class="img-fluid" alt="SMNS" />
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/pdf/Timetable/PNursery.pdf#toolbar=0" target="_blank">
                                <div class="sample-blk">
                                    <p>P NURSERY</p>
                                    <div class="lazyload-wrapper">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/pdf.png" class="img-fluid" alt="SMNS" />
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/pdf/Timetable/Nursery.pdf#toolbar=0" target="_blank">
                                <div class="sample-blk">
                                    <p>NURSERY</p>
                                    <div class="lazyload-wrapper">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/pdf.png" class="img-fluid" alt="SMNS" />
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default TimeTable